export default class Accordion {
    static key = 'Accordion';

    constructor(el, app) {
        this.el = el;
        this.app = app;
        this.buttons = this.el.querySelectorAll('.js-toggle-accordion');

        this.options = {
            notClosing: false,
        };

        this.init();
    }

    init() {
        this.setOptions();

        for (let i = 0; i < this.buttons.length; i++) {
            const button = this.buttons[i];

            button.addEventListener('click', this.toggleAccordion.bind(this));

            if ('autoOpen' in button.dataset) {
                button.classList.add('accordion__item--open');
            }
        }
    }

    setOptions() {
        if ('notClosing' in this.el.dataset) {
            this.options.notClosing = true;
        }
    }

    toggleAccordion(event) {
        const current = event.currentTarget;
        const isActive = current.classList.contains('accordion__item--open');
        const openItems = this.el.querySelectorAll('.accordion__item--open');

        if (isActive) {
            current.classList.remove('accordion__item--open');
            return;
        }

        if (!this.options.notClosing) {
            openItems.forEach((item) => {
                item.classList.remove('accordion__item--open');
            });
        }

        current.classList.add('accordion__item--open');
    }
}
